import InformationMessage from "./InformationMessage";

export default InformationMessage;
